// removed by extract-text-webpack-plugin
module.exports = {"content":"src-guides-css-modules-by-example----index-module---content---3fGe-","toc":"src-guides-css-modules-by-example----index-module---toc---21ds1"};


//////////////////
// WEBPACK FOOTER
// ./src/guides/css-modules-by-example/index.module.css
// module id = 651
// module chunks = 80394929847011